import styled from 'styled-components';

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const Label = styled.label<{ required?: boolean }>`
  display: block;
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.tertiary};

  ${({ required, theme }) => required && `
    &:after {
      content: '*';
      color: ${theme.colors.status.error};
      margin-left: ${theme.spacing.xs};
    }
  `}
`;

export const HelperText = styled.p<{ error?: boolean }>`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  color: ${({ error, theme }) =>
    error ? theme.colors.status.error : theme.colors.text.light};
  line-height: ${({ theme }) => theme.typography.lineHeight.relaxed};
`;

export const ErrorText = styled(HelperText).attrs({ error: true })`
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
`;
